import React, { useContext, useEffect, useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import ToolList from './components/ToolList';
import './App.css';
import './dark-theme.css';
import './light-theme.css';
import ThemeContext from "./components/ThemeContext";
import poeToolsData from './data/tools.json';
import diabloToolsData from './data/diablo-tools.json';
import arcRaidersToolsData from './data/arc-raiders-tools.json';
import ReactGA from "react-ga4";
import streamersPOEData from './data/streamers.json';
import streamersDiabloData from './data/diablo-streamers.json';
import streamersArcRaidersData from './data/arc-raiders-streamers.json';
import { Analytics } from "@vercel/analytics/react";
import { getDomainConfig } from './utils/domainConfig';

const initializeGoogleAnalytics = () => {
  const { gaTrackingId } = getDomainConfig();
  ReactGA.initialize(gaTrackingId);
};

const getInitialData = (domain, category) => {
  let toolsData;
  let streamersData;
  if (domain === 'diablotools.uk') {
    toolsData = diabloToolsData;
    streamersData = streamersDiabloData;
  } else if (domain === 'arcraiderstools.net') {
    toolsData = arcRaidersToolsData;
    streamersData = streamersArcRaidersData;
  } else {
    toolsData = poeToolsData;
    streamersData = streamersPOEData;
  }

  if (category === 'tools') {
    return { data: toolsData, toolCount: toolsData.length, streamerCount: streamersData.length };
  } else if (category === 'streamers') {
    return { data: streamersData, toolCount: toolsData.length, streamerCount: streamersData.length };
  }
  return { data: toolsData, toolCount: toolsData.length, streamerCount: streamersData.length };
};

function App() {
  const { theme } = useContext(ThemeContext);
  const [data, setData] = useState([]);
  const [toolCount, setToolCount] = useState(0);
  const [streamerCount, setStreamerCount] = useState(0);
  const [activeSection, setActiveSection] = useState('tools');
  const domain = process.env.REACT_APP_DOMAIN;

  useEffect(() => {
    initializeGoogleAnalytics();
    const initialData = getInitialData(domain, 'tools');
    setData(initialData.data);
    setToolCount(initialData.toolCount);
    setStreamerCount(initialData.streamerCount);
  }, [domain]);

  const handleSelectCategory = (category) => {
    setActiveSection(category);
    const categoryData = getInitialData(domain, category);
    setData(categoryData.data);
    setToolCount(categoryData.toolCount);
    setStreamerCount(categoryData.streamerCount);
  };

  return (
      <div id="root" className="App">
        <Header
            theme={theme}
            onSelectCategory={handleSelectCategory}
            toolsCount={toolCount}
            streamersCount={streamerCount}
            activeSection={activeSection}
        />
        <main className="main-content">
          <ToolList data={data} />
        </main>
        <Footer theme={theme} />
        <Analytics />
      </div>
  );
}

export default App;
